var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AddNewConnectResponseStatus } from "@/share/models";
import { action, makeObservable, observable } from "mobx";
import { NewConnectDialogState } from "@/app/UIComponents/NewConnectDialog";
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { WorkingDialogState } from "./WorkingDialogStore";
import { AppState } from "@/share/AppState";
export class ConnectViewState {
    constructor() {
        this.newconnectstate = new NewConnectDialogState();
        this.selected = new Set();
        this.connects = new Map();
        this.loadingconnects = true;
        this.deletigconnects = false;
        this.connectloadtstate = -1;
        this.externalWorkingDialog = new WorkingDialogState();
        makeObservable(this);
        APPEvent.addSubscriberForAppState((state) => {
            if (state === AppState.LoggedIn) {
                this.getConnects();
            }
        });
        APPEvent.addSubscriberForConnects((cn) => {
            console.log(cn);
            cn.forEach((c) => this.addConnect(c));
            this.setLoadingConnects(false);
            this.setConnectLoadState(1);
        });
        APPEvent.addSubscriberForAddConnect((c) => {
            if (c.res === AddNewConnectResponseStatus.Added) {
                this.addConnect(c);
            }
        });
        APPEvent.addSubscriberForDeleteConnect((c) => {
            if (this.deletigconnects) {
                if (c) {
                    this.selected.forEach((sel) => this.removeConnect(sel));
                }
                else {
                    APPEvent.publishApperror("Sorry but failed to delete connect" +
                        (this.selected.size > 1 ? 's' : '') + ". Please try again later.");
                }
                this.externalWorkingDialog.setOpen(false);
            }
            this.setDeleteConnects(false);
        });
    }
    deleteConnects() {
        if (this.selected.size > 0) {
            this.setDeleteConnects(true);
            this.externalWorkingDialog.setMessage("Deleting connect" + (this.selected.size > 1 ? 's' : ''));
            this.externalWorkingDialog.setLabel("Deleting");
            const req = { emails: Array.from(this.selected) };
            Apphandler.sendMessage("deleteconnects", req);
        }
    }
    setDeleteConnects(del) {
        this.deletigconnects = del;
    }
    setLoadingConnects(load) {
        this.loadingconnects = load;
    }
    addConnect(con) {
        this.connects.set(con.email, con);
    }
    removeConnect(email) {
        this.connects.delete(email);
    }
    clear() {
        this.connects.clear();
        this.selected.clear();
    }
    addSeleted(email) {
        this.selected.add(email);
    }
    removeSelected(email) {
        this.selected.delete(email);
    }
    toggleSelection(email) {
        if (this.selected.has(email)) {
            this.removeSelected(email);
        }
        else {
            this.addSeleted(email);
        }
    }
    get sortedConnects() {
        return Array.from(this.connects.values()).sort((a, b) => a.email.toLowerCase()
            .localeCompare(b.email.toLowerCase()));
    }
    setConnectLoadState(state) {
        this.connectloadtstate = state;
    }
    getConnects() {
        if (this.connectloadtstate < 0) {
            this.setConnectLoadState(0);
            Apphandler.sendMessage("getconnects", "");
        }
    }
    getConnect(email) {
        return this.connects.get(email);
    }
    reset() {
        this.clear();
        this.setConnectLoadState(-1);
    }
}
__decorate([
    observable,
    __metadata("design:type", Set)
], ConnectViewState.prototype, "selected", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ConnectViewState.prototype, "connects", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ConnectViewState.prototype, "loadingconnects", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ConnectViewState.prototype, "deletigconnects", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ConnectViewState.prototype, "connectloadtstate", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ConnectViewState.prototype, "setDeleteConnects", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ConnectViewState.prototype, "setLoadingConnects", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ConnectViewState.prototype, "addConnect", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ConnectViewState.prototype, "removeConnect", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ConnectViewState.prototype, "clear", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ConnectViewState.prototype, "addSeleted", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ConnectViewState.prototype, "removeSelected", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ConnectViewState.prototype, "setConnectLoadState", null);
